var _path, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9H4V4H9V9ZM3 11H10C10.552 11 11 10.552 11 10V3C11 2.448 10.552 2 10 2H3C2.448 2 2 2.448 2 3V10C2 10.552 2.448 11 3 11ZM20 9H15V4H20V9ZM14 11H21C21.553 11 22 10.552 22 10V3C22 2.448 21.553 2 21 2H14C13.447 2 13 2.448 13 3V10C13 10.552 13.447 11 14 11ZM15 20H20V15H15V20ZM21 22H14C13.447 22 13 21.553 13 21V14C13 13.447 13.447 13 14 13H21C21.553 13 22 13.447 22 14V21C22 21.553 21.553 22 21 22ZM9 20H4V15H9V20ZM3 22H10C10.552 22 11 21.553 11 21V14C11 13.447 10.552 13 10 13H3C2.448 13 2 13.447 2 14V21C2 21.553 2.448 22 3 22Z",
    fill: "#1A1A1A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9H4V4H9V9ZM3 11H10C10.552 11 11 10.552 11 10V3C11 2.448 10.552 2 10 2H3C2.448 2 2 2.448 2 3V10C2 10.552 2.448 11 3 11ZM20 9H15V4H20V9ZM14 11H21C21.553 11 22 10.552 22 10V3C22 2.448 21.553 2 21 2H14C13.447 2 13 2.448 13 3V10C13 10.552 13.447 11 14 11ZM15 20H20V15H15V20ZM21 22H14C13.447 22 13 21.553 13 21V14C13 13.447 13.447 13 14 13H21C21.553 13 22 13.447 22 14V21C22 21.553 21.553 22 21 22ZM9 20H4V15H9V20ZM3 22H10C10.552 22 11 21.553 11 21V14C11 13.447 10.552 13 10 13H3C2.448 13 2 13.447 2 14V21C2 21.553 2.448 22 3 22Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.7e0aa3d8.svg";
export { ForwardRef as ReactComponent };